<form #loginForm="ngForm" name="loginForm" class="m-0" (ngSubmit)="OnSubmit(Email.value, Password.value)" autocomplete="off">
  <div class="fieldset">
    <label for="Email" class="legend">Email</label>
    <input type="text" name="Email" id="Email" class="text-field" [disabled]="this.loginService_.isLoading" ngModel #Email required>
  </div>
  <div class="fieldset">
    <label for="Password" class="legend">Password</label>
    <input type="password" name="Password" id="Password" class="text-field" [disabled]="this.loginService_.isLoading" ngModel #Password required>
    <p class="text-links-wrap"><a routerLink="/access/forgotpassword" class="text-link">Forgot your password? </a><a routerLink="/access/resendemailverification" class="text-right text-link">Resend verification email</a></p>
  </div>
  <button *ngIf="!this.loginService_.isLoading; else isLoading" type="submit" class="btn m-auto" [disabled]="this.loginForm.invalid">Log in</button>
  <ng-template #isLoading>
    <button class="btn btn--loading" type="button">Logging in...</button>
  </ng-template>
  <div class="fieldset mt-3">
    <p class="text-center text-sm mb-1">Or</p>
    <hr class="m-0 mb-2"/>
      <iframe [src]="googleauthuri" width="100%" height="50px" scrolling="no" frameborder="0"></iframe>
  </div>
</form>